/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_sold_by_qty = /** @type {(inputs: { qty: NonNullable<unknown> }) => string} */ (i) => {
	return `Prodáno za ${i.qty}`
};

const da_sold_by_qty = /** @type {(inputs: { qty: NonNullable<unknown> }) => string} */ (i) => {
	return `Sælges i ${i.qty}`
};

const de_sold_by_qty = /** @type {(inputs: { qty: NonNullable<unknown> }) => string} */ (i) => {
	return `Verkauft in ${i.qty}`
};

const en_sold_by_qty = /** @type {(inputs: { qty: NonNullable<unknown> }) => string} */ (i) => {
	return `Sold by ${i.qty}`
};

const es_sold_by_qty = /** @type {(inputs: { qty: NonNullable<unknown> }) => string} */ (i) => {
	return `Vendido por ${i.qty}`
};

const fr_sold_by_qty = /** @type {(inputs: { qty: NonNullable<unknown> }) => string} */ (i) => {
	return `Vendu par ${i.qty}`
};

const hu_sold_by_qty = /** @type {(inputs: { qty: NonNullable<unknown> }) => string} */ (i) => {
	return `Értékesítés: ${i.qty}`
};

const it_sold_by_qty = /** @type {(inputs: { qty: NonNullable<unknown> }) => string} */ (i) => {
	return `Venduto per ${i.qty}`
};

const nl_sold_by_qty = /** @type {(inputs: { qty: NonNullable<unknown> }) => string} */ (i) => {
	return `Verkocht per ${i.qty}`
};

const pl_sold_by_qty = /** @type {(inputs: { qty: NonNullable<unknown> }) => string} */ (i) => {
	return `Sprzedawane po ${i.qty}`
};

const pt_sold_by_qty = /** @type {(inputs: { qty: NonNullable<unknown> }) => string} */ (i) => {
	return `Vendido por ${i.qty}`
};

const sv_sold_by_qty = /** @type {(inputs: { qty: NonNullable<unknown> }) => string} */ (i) => {
	return `Säljs i ${i.qty}`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ qty: NonNullable<unknown> }} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sold_by_qty = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sold_by_qty(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("sold_by_qty", locale)
	if (locale === "cs") return cs_sold_by_qty(inputs)
	if (locale === "da") return da_sold_by_qty(inputs)
	if (locale === "de") return de_sold_by_qty(inputs)
	if (locale === "en") return en_sold_by_qty(inputs)
	if (locale === "es") return es_sold_by_qty(inputs)
	if (locale === "fr") return fr_sold_by_qty(inputs)
	if (locale === "hu") return hu_sold_by_qty(inputs)
	if (locale === "it") return it_sold_by_qty(inputs)
	if (locale === "nl") return nl_sold_by_qty(inputs)
	if (locale === "pl") return pl_sold_by_qty(inputs)
	if (locale === "pt") return pt_sold_by_qty(inputs)
	return sv_sold_by_qty(inputs)
};